"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var Vimeo = /** @class */ (function () {
    function Vimeo(config) {
        this.providerDisplay = 'Vimeo';
        this.providerName = 'vimeo';
        this.providerUrl = 'https://vimeo.com';
        this.providerIcon = 'https://f.vimeocdn.com/images_v6/favicon.ico?DEV';
        this.type = 'video';
        // tslint:disable-next-line: max-line-length
        this.regex = /(?:http|https)?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|)(\d+)(?:|\/\?)/;
        this.idRegex = this.regex;
        this.baseOembedUrl = 'https://vimeo.com/api/oembed.json';
        this.config = __assign({}, config);
    }
    Object.defineProperty(Vimeo.prototype, "oembedParams", {
        get: function () {
            return {
                autoplay: this.config.autoplay ? '1' : '0',
                width: '1920',
            };
        },
        enumerable: true,
        configurable: true
    });
    Vimeo.prototype.getApiData = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var videoMatch, videoId, data, apiUrl, params, fetchUrl, response, _a, embed, pictures, thumbnail;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        videoMatch = url.match(this.idRegex);
                        videoId = videoMatch ? videoMatch[1] : undefined;
                        if (!videoId)
                            return [2 /*return*/];
                        // We need an token to make calls to the api.
                        if (!this.config.token)
                            return [2 /*return*/];
                        apiUrl = "https://api.vimeo.com/videos/" + videoId;
                        params = {
                            autoplay: this.config.autoplay ? '1' : '0',
                        };
                        fetchUrl = utils_1.buildUrl(apiUrl, params);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, utils_1.fetchRequest(fetchUrl, {
                                headers: { Authorization: "Bearer " + this.config.token },
                            })];
                    case 2:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        data = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        return [2 /*return*/];
                    case 5:
                        if (!data)
                            return [2 /*return*/];
                        embed = data.embed, pictures = data.pictures;
                        thumbnail = pictures.sizes[pictures.sizes.length - 1];
                        return [2 /*return*/, {
                                thumbnailUrl: thumbnail.link,
                                html: embed.html,
                                title: data.name,
                                description: data.description,
                                url: '',
                            }];
                }
            });
        });
    };
    return Vimeo;
}());
exports.Vimeo = Vimeo;
